import { ServiceBundle } from '../../../../models/service-bundle';
import { SaveServiceBundleForm } from './save-service-bundle.form';

interface CreateServiceBundleFormProps {
  projectID: number;
  onCompleted: (value: ServiceBundle) => void;
  refetch: () => void;
}

export const CreateServiceBundleForm = ({ projectID, onCompleted, refetch }: CreateServiceBundleFormProps) => {
  return <SaveServiceBundleForm projectID={projectID} onCompleted={onCompleted} refetch={refetch} />;
};
